<template>
    <div style="background: #00A916"  class="announcement" :initial-content="initialContent">
        <a v-on:click.prevent="toggle" class="close" href="#"></a>
        <div class="content" v-html="content"></div>
    </div>
</template>

<script>
    export default {
        name: "Announcement",
        props: {
            initialContent: String,
        },
        data() {
            return {
                bottomEdge: 16,
                bounceDistance: 3,
                animationDuration: 400,
                state: store.state,
                isOpen: false,
                content: ''
            }
        },
        computed: {
            message () {
                return this.state.announcementMessage;
            }
        },
        mounted() {
            if (this.initialContent) {
                this.content = this.initialContent;
                this.open();
            }
        },
        watch: {
            message (newMessage, oldMessage) {
                if (newMessage && newMessage !== oldMessage) {
                    this.content = newMessage;
                    if (!this.isOpen) {
                        this.open();
                    }
                } else if (newMessage === '') {
                    this.close(true);
                }
            }
        },
        methods: {
            toggle: function () {
                if (this.isOpen) {
                    this.close();
                } else {
                    this.open();
                }
            },
            open: function () {
                $(this.$el).css({
                    bottom: (this.bottomEdge / 2) + "px",
                    opacity: 0
                }).attr('state-active', true).animate({
                    bottom: this.bottomEdge + this.bounceDistance + "px",
                    opacity: 1
                }, this.animationDuration * 2/3 ).animate({
                    bottom: this.bottomEdge + "px",
                }, this.animationDuration / 3);

                this.isOpen = true;
            },
            close: function (cleared = false) {
                let component = this;

                if (this.isOpen) {
                    if (!cleared)
                        store.clearAnnouncementMessageAction();
                    $(this.$el).animate({
                        bottom: this.bottomEdge + this.bounceDistance + "px",
                    }, this.animationDuration / 3).animate({
                        bottom: (this.bottomEdge / 2) + "px",
                        opacity: 0,
                    }, this.animationDuration * 2/3, function () {
                        $(component.$el).attr('state-active', false);
                        if (cleared)
                            component.content = '';
                    });

                    this.isOpen = false;
                }
            }
        }
    }
</script>
